'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrowDirection = function arrowDirection(direction) {
  return direction === 'DOWN' ? 'rotate(180 5.5 7.5)' : null;
};

var TideArrow = function TideArrow(_ref) {
  var direction = _ref.direction;
  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 11 15', preserveAspectRatio: 'xMinYMin meet', className: 'quiver-tide-arrow' },
    _react2.default.createElement('polygon', {
      points: '5.5,0 11,5.5 8,5.5 8,15 3,15 3,5.5 0,5.5',
      transform: arrowDirection(direction)
    })
  );
};

TideArrow.propTypes = {
  direction: _propTypes2.default.oneOf(['UP', 'DOWN'])
};

TideArrow.defaultProps = {
  direction: 'UP'
};

exports.default = TideArrow;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TideArrow/TideArrow.js
// module id = 690
// module chunks = 11